import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=1b9470de&"
import script from "./Exam.vue?vue&type=script&lang=ts&"
export * from "./Exam.vue?vue&type=script&lang=ts&"
import style0 from "./Exam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports